import { cn } from '../cn.js';

export interface WordmarkProps {
  /** The product's name, as the application translates it. */
  readonly name: string;
  /** What the application is, when it is not the workspace: "Console", say. Quieter than the name. */
  readonly qualifier?: string | undefined;
  readonly className?: string | undefined;
}

/**
 * The product's mark and name, as the public site draws it.
 *
 * The site had a mark from M4.5-10 and the two applications behind it had a line of bold text, so
 * a person who came in through the site arrived somewhere that did not look like where they had
 * been (M5.5-01). The mark is the accent square the site uses; the qualifier is how the operator
 * console says it is the console without looking like a different product.
 *
 * It draws; it does not link. The application wraps it in its own router's link.
 */
export function Wordmark({ name, qualifier, className }: WordmarkProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-(--space-sm) whitespace-nowrap',
        'text-(length:--font-size-body-large) font-semibold text-(--color-text-primary)',
        className,
      )}
    >
      <span
        aria-hidden="true"
        className="size-(--size-icon-lg) shrink-0 rounded-(--radius-md) bg-(--color-accent)"
      />
      {name}
      {qualifier === undefined ? null : (
        <span className="font-normal text-(--color-text-muted)">{qualifier}</span>
      )}
    </span>
  );
}
